import Contact from "../components/contact_contact_page/Contact";

const Contact_page = () => {
  return <>
    <Contact />
  </>;
};
export default Contact_page;